import { useDispatch, useSelector } from "react-redux";
import { uiActions, visualizerActions } from "../../store";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";

import FacebookShareLink from "../FacebookShareLink/FacebookShareLink";
import XShareLink from "../XShareLink/XShareLink";
import PintrestShareLink from "../PintrestShareLink/PintrestShareLink";
import { EmailShareLink } from "../EmailShareModal/EmailShareModal";
import PopUpModal from "../PopUpModal/PopUpModal";
import FormInput from "../FormInput/FormInput";

import { generateShareLink } from "../../Helpers/ShareHelper";

import styles from "./ShareModal.module.css";


export default function ShareModal() {

    const dispatch = useDispatch();
    const shareData = useSelector(state => state.visualizer.shareData);
    const activePattern = useSelector(state => state.visualizer.activePattern);
    const selectedSlotProducts = useSelector(state => state.visualizer.selectedSlotProducts);
    const [shareUrl, setShareUrl] = useState('');
    const [formValidity, setFormValidity] = useState({});

    const handleClose = function () {
        dispatch(uiActions.setShareModalActive(false));
    }

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            // You could add a toast notification here if needed
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };
    
    // Generate share URL in the new format
    const generateShareUrl = () => {
        if (!activePattern) {
            return '';
        }
        
        const { origin } = window.location;
        const patternId = activePattern.id || activePattern.patternId || '';
        
        // Get selected product IDs
        const productIds = [];
        if (activePattern.descriptor) {
            const colorSlots = activePattern.descriptor.split(',').map(slot => slot.trim());
            colorSlots.forEach((slot, index) => {
                const product = selectedSlotProducts[index];
                if (product && product.id) {
                    productIds.push(product.id);
                } else {
                    productIds.push('-1');
                }
            });
        }
        
        // Build URL: baseUrl/visualizer/pattern/{patternId}/products/{productIds}
        const productIdsString = productIds.length > 0 ? productIds.join(',') : '-1';
        return `${origin}/visualizer/pattern/${patternId}/products/${productIdsString}`;
    };

        useEffect(() => {
            // Generate the new format share URL
            const newShareUrl = generateShareUrl();
            if (newShareUrl) {
                setShareUrl(newShareUrl);
                
                // Update share data in store
                const updatedShareData = {
                    ...shareData,
                    url: newShareUrl
                };
                dispatch(visualizerActions.setShareData(updatedShareData));
            }
        }, [activePattern, selectedSlotProducts]);

    return (
        <>
            <PopUpModal handleClose={handleClose}>
                <div className={styles.contentMain}>
                    <h2>Share Your Project</h2>
                    <div className={styles.flexRow}>
                        <div className={styles.shareUrlContainer}>
                            <div className={styles.inputWrapper}>
                                <label htmlFor="shareUrl">Share URL</label>
                                <input 
                                    id="shareUrl"
                                    type="text"
                                    value={shareUrl}
                                    readOnly
                                    className={styles.shareUrlInput}
                                />
                            </div>
                            <button 
                                className={styles.copyButton}
                                onClick={handleCopy}
                            >
                                COPY
                            </button>
                        </div>
                    </div>
                </div>
            </PopUpModal>
        </>
    );
}
